import { Flex as MantineFlex } from "@mantine/core";

export const Flex = MantineFlex;
